var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 20.03 8.19 C 22 18 11 23 2.5 17.51 C 4.597 17.732 6.703 17.189 8.43 15.98 C 6.778 15.979 5.294 14.968 4.69 13.43 C 5.29 13.53 5.91 13.51 6.5 13.35 C 4.75 13.03 3.22 11.48 3.28 9.74 L 3.28 9.69 C 3.84 9.98 4.46 10.13 5.1 10.15 C 3.384 9.14 2.826 6.922 3.86 5.22 C 5.959 7.597 8.95 8.995 12.12 9.08 C 11.18 5.38 15.92 2.9 18.95 5.72 C 19.85 5.55 20.71 5.25 21.49 4.82 C 21.543 6.107 21.006 7.348 20.03 8.19 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.67ad0b4a506fe4505be1e6aed1c49ff3.svg";
export { ForwardRef as ReactComponent };